import {
  HotelQueryStringFilterKeys,
  CruiseQueryStringFilterKeys,
  FlightQueryStringFilterKeys,
  CarQueryStringFilterKeys,
  CustomInventoryQueryStringFilterKeys,
  TourQueryStringFilterKeys,
} from '../constants';
import { isFlightSelectionParam } from './removeFlightSelectionParams';

export default function getBaseQueryFromRouterQuery(_routerQuery) {
  // except auth0 params
  const { code, state, ...routerQuery } = _routerQuery;
  const nonValidQueryNames = HotelQueryStringFilterKeys.concat(CruiseQueryStringFilterKeys)
    .concat(FlightQueryStringFilterKeys)
    .concat(CarQueryStringFilterKeys)
    .concat(CustomInventoryQueryStringFilterKeys)
    .concat(TourQueryStringFilterKeys);
  const filteredQuery = {};
  // pick only valid properties
  Object.keys(routerQuery).forEach((queryName) => {
    if (isFlightSelectionParam(queryName)) return;
    if (!nonValidQueryNames.some((filterName) => queryName.includes(filterName))) {
      filteredQuery[queryName] = routerQuery[queryName];
    }
  });
  return filteredQuery;
}
